// extracted by mini-css-extract-plugin
export default {"total-test":"dashboard_total-test__H6jcF","finished-test":"dashboard_finished-test__JzkMY","profile-percentage":"dashboard_profile-percentage__dv+xV"};